module.exports = __webpack_public_path__ + "img/免疫系统-.fffa15f7.png";